import * as L from "leaflet";
import { emptyCircleSvg, halfCircleSvg, fullCircleSvg, crossedCircleSvg } from "../svg";

export type Bucket = 1 | 2 | 3 | 4;

const iconFromSvg = (svg: string) =>
  L.divIcon({
    html: `<div class="delay-dot">${svg}</div>`,
    className: "delay-icon",
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

const iconEmpty = iconFromSvg(emptyCircleSvg());
const iconHalf  = iconFromSvg(halfCircleSvg());
const iconFull  = iconFromSvg(fullCircleSvg());
const iconCross = iconFromSvg(crossedCircleSvg());

export function iconForBucket(b: Bucket) {
  if (b === 1) return iconEmpty;
  if (b === 2) return iconHalf;
  if (b === 3) return iconFull;
  return iconCross;
}
